const t = "(max-width: 499px)", E = "(min-width: 2540px)";
export {
  E as MEDIA_QUERY_LARGE,
  t as MEDIA_QUERY_SMALL
};
